import {
  House,
  Ticket,
  User,
  Bell,
} from '@phosphor-icons/react'

const menu = [
  {
    titleKey: 'Support',
    items: [
      { labelKey: 'dashboard',        path: '/',               icon: House },
      { labelKey: 'submittedTickets', path: '/tickets',        icon: Ticket },
    ],
  },
  {
    titleKey: 'Account',
    items: [
      { labelKey: 'profile',       path: '/profile',       icon: User },
      { labelKey: 'notifications', path: '/notifications', icon: Bell },
    ],
  },
]

export default menu
